export const EU_DOMAINS = [
  'dev2.americangolf.eu',
  'dev-eu.americangolf.co.uk',
  'www.americangolf.eu',
  'testapplepay.ngrok.io',
  'staging.americangolf.eu',
  'qa.americangolf.eu',
  'preprod.americangolf.eu',
  'eu',
  '127.0.0.1',
];
